<form autocomplete="off" [name]="formName" [id]="formName" [formGroup]="formControl">
    <shared-forms-input [disabled]="disabled" (onChange)="handlePeriodChange($event)" [showHint]="false"
        selectWidth="full" selectDropdownSize="md" [selectOptions]="periods" type="select" [compact]="compact"
        [parentForm]="formControl" name="period">
    </shared-forms-input>
    <ng-template #optionTemplate let-item="item">
        {{item?.ShortName || item?.Name}}
    </ng-template>
    <shared-forms-input [disabled]="disabled" [selectedTemplate]="optionTemplate" [optionTemplate]="optionTemplate"
        [showHint]="false" selectWidth="full" selectDropdownSize="md" [selectOptions]="pickupsList" type="select"
        [compact]="compact" [parentForm]="formControl" name="pickupTime">
    </shared-forms-input>
</form>